import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';
import {
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import type {
  IPostbacksUriOptionsSaveResponse,
  IPostbackUriOption,
} from '../types';
import {
  ADMIN_POSTBACKS_URL_OPTIONS_SAVE_URL,
  AFFILIATE_POSTBACKS_URL_OPTIONS_SAVE_URL,
  POSTBACKS_SAVE_URL_OPTION_MUTATION_KEY,
} from '../constants';

function getPostbackUrlOptionSaveUrl(isAdminNamespace: boolean): string {
  if (isAdminNamespace) {
    return ADMIN_POSTBACKS_URL_OPTIONS_SAVE_URL;
  }

  return AFFILIATE_POSTBACKS_URL_OPTIONS_SAVE_URL;
}

export default function usePostbackUrlOptionSaveMutation(): IContextMutationResult<
  IPostbacksUriOptionsSaveResponse,
  Error,
  IPostbackUriOption
> {
  const { fetchPut, fetchPost } = useRestClient();
  const { isAdminNamespace } = useCurrentNamespace();

  return useContextMutation<IPostbacksUriOptionsSaveResponse, Error, IPostbackUriOption>({
    mutationKey: [POSTBACKS_SAVE_URL_OPTION_MUTATION_KEY],
    mutationFn: ({
      affiliateId,
      postbackId,
      ...uri_option
    }) => (
      uri_option.id
        ? fetchPut<IPostbacksUriOptionsSaveResponse>(
            getPostbackUrlOptionSaveUrl(isAdminNamespace.value),
            {
              uri_option,
            },
            {
              permission: POSTBACKS_PERMISSIONS.SHOW,
              urlParams: {
                id: affiliateId,
                postbackId,
                optionId: uri_option.id,
              },
            },
          )
        : fetchPost<IPostbacksUriOptionsSaveResponse>(
            getPostbackUrlOptionSaveUrl(isAdminNamespace.value),
            {
              uri_option,
            },
            {
              permission: POSTBACKS_PERMISSIONS.SHOW,
              urlParams: {
                id: affiliateId,
                postbackId,
                optionId: uri_option.id,
              },
            },
          )
    ),
  });
}
